import * as Yup from "yup";

export const schema = Yup.object().shape({
  message: Yup.string().required("Введите причину удаления").max(100, "Максимальное значение 100"),
});
